import Dropdown from 'react-bootstrap/Dropdown'
import {useState} from "react";
import InputError from "./InputError";

function optionValue(obj) {
    return obj?.value ?? obj?.title ?? obj?.name;
}

function optionLabel(obj) {
    return obj?.title ?? obj?.name ?? obj?.value;
}

function labelFor(options, key) {
    const match = options?.find((obj) =>
        String(optionValue(obj)) === String(key)
        || obj?.title?.toString() === String(key)
        || obj?.name?.toString() === String(key)
    );
    return match ? optionLabel(match) : key;
}

function MazhrDD({ options, defaultValue, onSelectFunc, errorContent, doValidation, label, id}) {

    if (!defaultValue){
        defaultValue = 'Select'
    }
    const [ isItemSelected, setIsItemSelected ] = useState(false);
    const [ selectedOption, setSelectedOption ] = useState(labelFor(options, defaultValue));

    function onSelect(eventKey){
        if(!isItemSelected) {
            setIsItemSelected(true)
        }
        setSelectedOption(labelFor(options, eventKey))
        onSelectFunc(eventKey, id)
    }

    return (
        <div className="form-field">
            {label ? <label>{label}</label> : ''}
            <div className="input-wrapper">
                <Dropdown onSelect={onSelect} className="dropdownWrapper full-width" >
                    <Dropdown.Toggle id="dropdown-autoclose-true" className='fullLengthDropdown'>
                        {selectedOption}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className='options-bar'>
                        {options? options?.map((obj, index )=> (
                            <Dropdown.Item key={index} active={(optionLabel(obj)?.toString() === selectedOption.toString())} eventKey={optionValue(obj)} href="#">
                                {optionLabel(obj)}
                            </Dropdown.Item>
                        )):null}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            {!isItemSelected && doValidation ? <InputError errors={!isItemSelected && doValidation} errorMessage={errorContent}/> : ''}
        </div>
    )
}

export default MazhrDD;



